import http from "../../services/http";
import { handleErrors } from "../../helpers/error";
import {
  getGiftsCards,
  getProductListing,
  getSingleProdutPackages,
} from "../auth/productsListing";
import storage from "../../services/storage";
import { digitalProductResp } from "../api/digitalProduct";
const path = "v1/admin/product";
const path3 = "v1/admin/gift-card";
const path2 = "v1/admin/product/getall/";
const path4 = "v1/admin/product/eachProduct/";
const path5 = "v1/admin/product/getDistinctPrices";
export const getDistinctPricesApi = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: path5,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });
      onSuccess(res);
      // dispatch(getGiftsCards(res.data.data));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const GetProductApi = ({
  onSuccess,
  onError,
  price,
  sortOrder,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: `${path}?sortOrder=${sortOrder}&price=${price}`,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          "x-store-id": (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
      dispatch(getProductListing(res.data.data));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const GetGiftCardsApi = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: path3,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });
      onSuccess(res);
      dispatch(getGiftsCards(res.data.data));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const GetSingleProductApi = ({
  id = "",
  giftCard,
  onSuccess,
  onError,
  onEnd,
}) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: `${giftCard ? `${path3}/` : path4}${id}`,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess(res);
      dispatch(getSingleProdutPackages(res.data.data));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export const buyDigitalProduct = ({ id, onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.post({
        url: `v1/checkout/buy/${id}`,
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
          'x-store-id': (storage.get("xStoreId") || null),
        },
      });
      onSuccess?.(res);
      // console.log("digital", res);
      dispatch(digitalProductResp(res?.data));
      // console.log("resp arry ", res.data.data[0].data);
    } catch (error) {
      // console.log("in error=====>", error.response.message);
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
